import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomerLandingPage } from '@/areas/customers/CustomerLanding/pages/CustomerLandingPage';
import { canViewCustomerLandingPage } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/start')({
    staticData: { access: { permissions: canViewCustomerLandingPage }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomerLandingPage />;
}
